module.exports = __webpack_public_path__ + "static/media/W_Calendar_03.476d3a0c.png";